import yup from '../../../config/yup';

export const updateValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('update'),
  action: yup.string().default('UPDATE').required('Action is required'),
  command: yup
    .string()
    .default('UPDATE')
    .required('Command is required')
    .matches(/^UPDATE\s+\S+/i, "Command must start with 'UPDATE' followed by at least one word"),
});
